import { Button } from "@/shared/components";

import InvoiceLineTable from "../InvoiceLineTable";
import { INVOICE_PREVIEW_COLUMNS } from "../../constants/invoiceLineColumns";
import type { InvoiceLineItem, InvoiceTaxSplit } from "../../types";

type InvoicePreviewStepProps = {
  lines: InvoiceLineItem[];
  taxSplit: InvoiceTaxSplit;
  isSubmitting?: boolean;
  onBack: () => void;
  onSaveDraft: () => void;
};

const EMPTY_VALUE = "-";

export default function InvoicePreviewStep({
  lines,
  taxSplit,
  isSubmitting = false,
  onBack,
  onSaveDraft,
}: InvoicePreviewStepProps) {
  const summaryTiles = [
    { key: "lines", label: "Lines", value: EMPTY_VALUE },
    { key: "commission", label: "Commission", value: EMPTY_VALUE },
    { key: "tax", label: taxSplit.taxLabel, value: EMPTY_VALUE, hint: taxSplit.label },
    { key: "total", label: "Invoice total", value: EMPTY_VALUE, highlight: true },
  ];

  return (
    <div className="space-y-4">
      {/* Summary bar */}
      <div className="grid grid-cols-2 gap-4 rounded-lg border border-theme-border bg-theme-surface-soft p-4 sm:grid-cols-4">
        {summaryTiles.map((tile) => (
          <div key={tile.key}>
            <p className="text-xs font-semibold uppercase tracking-wide text-theme-text-soft">
              {tile.label}
            </p>
            <p
              className={`mt-1 text-xl font-bold ${
                tile.highlight ? "text-theme-primary" : "text-theme-text"
              }`}
            >
              {tile.value}
            </p>
            {tile.hint ? <p className="mt-0.5 text-xs text-theme-text-soft">{tile.hint}</p> : null}
          </div>
        ))}
      </div>

      <InvoiceLineTable
        columns={INVOICE_PREVIEW_COLUMNS}
        rows={lines}
        emptyText="Lines will appear here once the generate-invoice API is connected"
      />

      <div className="flex justify-end gap-3 border-t border-theme-border pt-4">
        <Button type="button" variant="secondary" disabled={isSubmitting} onClick={onBack}>
          Back
        </Button>
        <Button
          type="button"
          disabled={isSubmitting}
          isLoading={isSubmitting}
          onClick={onSaveDraft}
        >
          Save as Draft
        </Button>
      </div>
    </div>
  );
}
